
import { Helmet } from 'react-helmet-async';

interface OpenGraphMetaProps {
  title: string;
  description: string;
  canonical: string;
  ogType: string;
  ogImage: string;
}

const OpenGraphMeta = ({
  title,
  description,
  canonical,
  ogType,
  ogImage
}: OpenGraphMetaProps) => {
  return (
    <Helmet>
      {/* Enhanced Open Graph / Facebook */}
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={canonical} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content={title} />
      <meta property="og:site_name" content="Groupe Fabre Environnement" />
      <meta property="og:locale" content="fr_FR" />
      
      {/* Enhanced Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={canonical} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      <meta name="twitter:image:alt" content={title} />
      <meta name="twitter:creator" content="@GroupeFabre" />
      <meta name="twitter:site" content="@GroupeFabre" />
    </Helmet>
  );
};

export default OpenGraphMeta;
